module.exports = __webpack_public_path__ + "img/icon-pinjol.631d1185.svg";